import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import HttpRoute from "../../../dce-ajax/lib/utils/HttpRoute";
import {DceAjax} from "dce-ajax";
import {CancelTokenSource} from "axios";

interface SearchAutocompleteProps {
    call: string;
}

@Dce("SearchAutocomplete")
export default class SearchAutocomplete extends DceComponent<SearchAutocompleteProps> {

    private route: HttpRoute;
    private cont: JQuery<HTMLElement>;
    private input: JQuery<HTMLElement>;
    private target: JQuery<HTMLElement>;

    private timeout: any;
    private reqCancelTokenSource: CancelTokenSource;

    constructor(elem: DceHTMLElement, props: SearchAutocompleteProps) {
        super(elem, props);
        this.route = HttpRoute.of(this.props.call);

        this.cont = $(this.elem);
        this.input = this.cont.find('input[ref="input"]');
        this.target = this.cont.find('div[ref="target"]');

        console.log("AXXX", this.input);

        elem.addEventListener('input', ev => {
            this.makeCall(this.input.val().toString());
        })
    }


    public makeCall(value: string) {
        if (null != this.reqCancelTokenSource) {
            console.log('Canceling req');
            this.reqCancelTokenSource.cancel("Canceling request");
            this.reqCancelTokenSource = null;
        }

        if (null != this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        if (value != '' && value.length > 3) {

            console.log('value', value);

            this.target.addClass('loading');

            this.timeout = setTimeout(() => {
                this.reqCancelTokenSource = DceAjax.cancelTokenSource();
                this.timeout = null;

                let data = new FormData();
                data.set('q', value);

                DceAjax.getInstance()
                    .post(this.route.build(), data, {
                        cancelToken: this.reqCancelTokenSource.token
                    })
                    .then(e => {
                        this.reqCancelTokenSource = null;
                        this.target.removeClass("loading");

                        this.target.html(e.response);
                    });
            }, 300);

        }
    }

}
